import { render } from "./FlowerIcon.vue?vue&type=template&id=fda53972"
import script from "./FlowerIcon.vue?vue&type=script&lang=js"
export * from "./FlowerIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__